import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import OrderHistorySection from "../../components/Orders/OrderHistorySection";
import Page from "../../components/Page";
import {
  getOrderDetail,
  getOrderDetailClear,
  getOrderHistory,
  getOrderHistoryClear,
} from "../../redux/orders/actions";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import OrderHistorySectionCopy from "../../components/Orders/OrderHistorySectionCopy";
import { getActiveHeader } from "../../redux/home/actions";
import useLogin from "../../custom-hooks/useLogin";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const OrderHistoryPageCopy = () => {
  const dispatch = useDispatch();
  const orderHistory = useSelector((state) => state.orders.orderHistory);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [ordersData, setOrdersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrdersDataFinal, setOrdersDataFinal] = useState([]);
  let navigate = useNavigate();

  const observer = useRef();
  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );
  const [hasNoMore, setHasNoMore] = useState(true);
  const [pageNum, setPageNum] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const { isLoggedIn } = useLogin();
  const location = useLocation();

  useEffect(() => {
    dispatch(getActiveHeader(""));

    if (!localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
      const domainArray = window.location.host.split(".");
      const subDomain = domainArray[0];
      const locationPath = {
        path: location.pathname,
        query: location.search,
        // company: subDomain,
      };
      localStorage.setItem(
        SessionKeys.LOCATION_PATH_REDIRECT,
        JSON.stringify(locationPath)
      );
      console.log(
        "check--",
        !localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        subDomain,
        locationPath,
        localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)
      );
      navigate("/login", { state: locationPath });
    }
  }, []);

  const [apiCalled, setApiCalled] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [searchedOrNot, setsearchedOrNot] = useState(false);

  const getOrdersAPI = (pageNum) => {
    dispatch(
      getOrderHistory({
        module: "getOrderHistory",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          // page: pageNum,
          // page_size: pageSize,
        },
      })
    );
  };

  useEffect(() => {
    if (authBroker?.payload?.user?.user_id) {
      getOrdersAPI(1);
      setApiCalled(true);
      clickStreamUser("Order History Page", {
        userId: authBroker?.payload?.user?.user_id,
      });
      // dispatch(getOrderHistoryClear());
    }
  }, [dispatch, authBroker]);

  // useEffect(() => {
  //   getOrdersAPI(pageNum);
  //   // return () => {
  //   //   dispatch(getOrderHistoryClear());
  //   // };
  // }, [pageNum]);

  const [allRecords, setAllRecords] = useState([]);

  useEffect(() => {
    console.log("orderData: ", orderHistory);
    if (!_.isEmpty(orderHistory) && apiCalled) {
      if (orderHistory?.status === "success") {
        let ordersDatClone = _.cloneDeep(orderHistory?.payload);
        console.log("recordsLength-1", orderHistory?.payload?.total_record);
        setTotalRecords(ordersDatClone?.length);
        setOrdersDataFinal(ordersDatClone);
        // setOrdersData(ordersDatClone.slice(0, pageNum * 5)); // 0 - 5-1 -> 0,4 - 5 records.
        let orderWithYear = [];
        for (const item of ordersDatClone) {
          if (
            item.order_completed?.date.includes(
              new Date().getFullYear().toString()
            )
          ) {
            orderWithYear.push(item);
          }
        }
        setOrdersData(orderWithYear);
        setAllRecords(ordersDatClone);
        setIsLoading(false);
      } else {
        setOrdersData([]);
        setIsLoading(false);
      }
    }
  }, [orderHistory]);

  // useEffect(() => {
  //   console.log("searchedOrNot", !searchedOrNot);
  //   if (!searchedOrNot) {
  //     // setOrdersData(allRecords.slice((pageNum - 1) * 5, pageNum * 5)); // 1*5, 10-1 , 5-9
  //     setOrdersData(allRecords);
  //   } else {
  //     setIsLoading(false);
  //   }
  //   setsearchedOrNot(false);
  // }, [pageNum]);

  useEffect(() => {
    console.log("searchedOrNot--", searchedOrNot);
  }, [searchedOrNot]);

  // const paginateCB = useCallback(
  //   (node) => {
  //     if (isLoading) return;

  //     if (observer.current) observer.current.disconnect();

  //     observer.current = new IntersectionObserver((entries) => {
  //       if (entries[0].isIntersecting && !hasNoMore) {
  //         setIsLoading(true);
  //         // console.log('End of file', totalRecords, lpListing.length, pageNum, isLoading, isFetching)
  //         console.log("page no", pageNum);
  //         setPageNum((pageNum) => pageNum + 1); //pageNum => pageNum + 1
  //         // setOrdersData((prevRecords) => [...prevRecords, ...ordersData]);
  //         // setOrdersData([
  //         //   ...ordersData,
  //         //   ...CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_ORDERS,
  //         // ]);
  //       }
  //     });

  //     if (node) observer.current.observe(node);
  //     console.log(node);
  //   },
  //   [hasNoMore]
  // );

  useEffect(() => {
    console.log("orders data--", ordersData);
    return () => {};
  }, [ordersData]);

  useEffect(() => {
    console.log("pageno--", pageNum);
    return () => {};
  }, [pageNum]);

  const [isFetching, setIsFetching] = useState(false);

  const filterWithYear = (value) => {
    console.log("temparr selectedYear--", value);
    let orders = _.cloneDeep(OrdersDataFinal);
    console.log("check1", orders, value);
    if (value === "") {
      setOrdersData(orders);
      return;
    }
    let tempArr = [];
    for (const item of orders) {
      if (item.order_completed?.date.includes(value)) {
        tempArr.push(item);
      }
    }
    setOrdersData(tempArr);
    console.log("check1-2 temparr--", tempArr, tempArr.length);
    setTotalRecords(tempArr?.length);
  };

  return (
    <>
      <Page>
        <OrderHistorySectionCopy
          ordersData={ordersData}
          ordersDataFinal={OrdersDataFinal}
          isLoading={isLoading}
          // paginateCB={paginateCB}
          setIsLoading={setIsLoading}
          setIsFetching={setIsFetching}
          isFetching={isFetching}
          pageNum={pageNum}
          searchedOrNot={searchedOrNot}
          setsearchedOrNot={setsearchedOrNot}
          setPageNum={setPageNum}
          setHasNoMore={setHasNoMore}
          totalrecords={totalRecords}
          filterWithYear={filterWithYear}
        />
      </Page>
    </>
  );
};

export default OrderHistoryPageCopy;
